import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

// This needs to be in a separate file so that resizes don't cause the child tab routes to remount

function TabIndicator(props) {
  const [fontsLoaded, setFontsLoaded] = useState(false);
  const [tabPosition, setTabPosition] = useState({ offsetLeft: 0, offsetWidth: 0 });
  const isCancelled = useRef(false);
  const indicatorLeft = props.activeTabRef.current?.offsetLeft;

  const updatePosition = useCallback(
    () => {
      if (props.activeTabRef.current) {
        const { offsetLeft, offsetWidth } = props.activeTabRef.current;
        if (isCancelled.current) return;
        setTabPosition({ offsetLeft, offsetWidth });
      }
    },
    [props.activeTabRef, indicatorLeft] // eslint-disable-line
  );

  useEffect(() => {
    return () => (isCancelled.current = true);
  }, []);

  // When fonts load, width of tabs will change
  useEffect(() => {
    if (!document.fonts) return;
    document.fonts.ready.then(() => {
      if (isCancelled.current) return;
      updatePosition();
      setFontsLoaded(true);
    });
  }, [updatePosition]);

  // Need to adjust position of indicator as window resizes
  useEffect(() => {
    window.addEventListener('resize', updatePosition, { passive: true, capture: true });
    return () => window.removeEventListener('resize', updatePosition);
  }, [updatePosition]);

  useEffect(updatePosition, [updatePosition, props.activeTabIndex]);

  if (fontsLoaded) {
    return (
      <span
        className={classnames([styles.tabIndicator, ...props.styles])}
        style={{ left: tabPosition.offsetLeft, width: tabPosition.offsetWidth }}
      />
    );
  }

  return null;
}

TabIndicator.propTypes = {
  activeTabIndex: PropTypes.number.isRequired,
  activeTabRef: PropTypes.shape({
    current: PropTypes.object
  }).isRequired,
  styles: PropTypes.array
};

TabIndicator.defaultProps = {
  styles: []
};

export default TabIndicator;
